// Dependencies
import React from 'react';
import Image from 'react-image-resizer';

// Assets
import './Place.css';


const style = {
  image: {
    transform: 'translate(-50%, -50%)'
  }
};


const Place = ({ text, icon, defaultIcon }) =>
  <div className="Place">
    {/* <img className="PlaceIcon img-fluid" src={icon} alt={text}/> */}
    <Image
      src={icon || defaultIcon}
      noImageSrc={defaultIcon}
      alt={text}
      width={35}
      height={35}
      style={style.image}
    />
  </div>;

export default Place;
